<template>
  <div
    ref="section"
    :class="{'animate__animated animate__backInDown': animate}"
    class="relative overflow-hidden montserrat md:px-0 px-6 md:w-[90%] flex flex-col flex-wrap top-20 md:m-20 container mb-32"
  >
    <p class="md:text-4xl text-xl text-white font-bold">Why UX?</p>
    <p class="md:text-xl text-md mt-10 text-white">
      I have always been intrigued by how technology can connect people. I decided to pursue a career in Human-computer interaction, where I could combine my curiosity, creativity, and technical skills to craft meaningful and innovative user experiences.
    </p>
    <p class="md:text-xl text-md mt-10 text-white">
      I am highly motivated to explore new challenges and expand my knowledge and abilities.
    </p>
  </div>
</template>

<script>
export default {
  name: 'WhyuiuxParagraph',
  data() {
    return {
      animate: false,
    };
  },
  mounted() {
    const options = {
      root: null,
      threshold: 0.1,
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.animate = true;
          observer.unobserve(entry.target);
        }
      });
    }, options);
    observer.observe(this.$refs.section);
  },
};
</script>

<style scoped>
@import "https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css";
@media (max-width:730px) {
  .whyUx {
    width: 200px;
  }
}
</style>
